export default "__VITE_ASSET__0f622256__"